import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { IconComponent } from '@big-direkt/utils/icons';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardBaseComponent } from '../../card-base.component';
import { CardComponent } from '../card/card.component';
import { UiCardDashboardModel } from './card-dashboard.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-dashboard',
    templateUrl: './card-dashboard.component.html',
    imports: [CardComponent, NgClass, UiLinkComponent, UiSvgIconModule, IconComponent, TranslocoDirective],
})
export class CardDashboardComponent extends CardBaseComponent {
    @Input() public data!: UiCardDashboardModel;
    @Input() public iconCssClass = 'fill-primary group-hover/item:fill-primary-300';
    @Input() public iconSvgCssClass = 'flex shrink-0 w-8 mr-4 fill-primary group-hover/item:fill-primary-300';
}
